import PropTypes from 'prop-types';
import React from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { ButtonLink } from './ButtonLink';

const styles = (theme) => ({
  tabContainer: {},
  title: {},
  subtext: {},
});

const DefaultSuccessTabComponent = ({ classes, title, subtext, message, onCloseHandler, t }) => (
  <div className={classes.tabContainer}>
    <h1 className={classes.title}>{title}</h1>
    <p className={classes.subtext}>{subtext}</p>
    <p className={classes.subtext}>{message}</p>
    <div className={classes.cancelBtn}>
      <ButtonLink onClick={onCloseHandler}>{t('accessible_close_button', 'Close')}</ButtonLink>
    </div>
  </div>
);
DefaultSuccessTabComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  handleTabChange: PropTypes.func.isRequired,
};

export const DefaultSuccessTab = withStyles(styles)(withNamespaces()(DefaultSuccessTabComponent));
